import type { HotelPublicContent } from '@bandido/shared/types/hotels/hotel-content';

export interface HotelLocationPoint {
  latitude: number;
  longitude: number;
}

export function publishedHotelPoint(content?: HotelPublicContent | null): HotelLocationPoint | null {
  if (content?.status !== 'published') return null;
  const { latitude, longitude } = content.location ?? {};
  if (
    typeof latitude !== 'number' ||
    !Number.isFinite(latitude) ||
    Math.abs(latitude) > 90 ||
    typeof longitude !== 'number' ||
    !Number.isFinite(longitude) ||
    Math.abs(longitude) > 180
  ) {
    return null;
  }
  return { latitude, longitude };
}

/** Provider URL boundary: use the published point, never a guessed name/address match. */
export function googleMapsLocationUrl(point: HotelLocationPoint): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${point.latitude},${point.longitude}`)}`;
}
